var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ci-card ci-user-tile", class: _vm.classes },
    [
      _c("div", { staticClass: "ci-user-tile__inner d-flex flex-row mb-2" }, [
        _c(
          "div",
          {
            staticClass: "ci-user-tile__img d-flex cursor-pointer",
            class: { "align-items-center": _vm.advisorTile },
          },
          [
            _c(
              "ci-router-link",
              {
                staticClass: "d-block pr-xs-3 pb-2 pb-xs-0",
                attrs: { disabled: _vm.linkDisabled, to: _vm.linkWithTracking },
              },
              [
                _c("ci-user-avatar", {
                  staticClass: "avatar flex-shrink-0",
                  attrs: {
                    src: _vm.user.avatar,
                    size: _vm.size,
                    showVerifiedBadge: _vm.user.verified,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "ci-user-tile__content flex-grow-1 d-flex flex-column cursor-pointer",
          },
          [
            _c(
              "div",
              { staticClass: "ci-user-tile__profile-data flex-grow-1 h-100" },
              [
                _c(
                  _vm.tileHtmlComponent,
                  _vm._b(
                    {
                      tag: "div",
                      staticClass:
                        "d-flex flex-column flex-md-row align-items-center align-items-xs-start h-100",
                      class: _vm.linkClass,
                    },
                    "div",
                    {
                      to: _vm.withSendMessage ? false : _vm.linkWithTracking,
                      disabled: _vm.linkDisabled,
                    },
                    false
                  ),
                  [
                    _c(
                      "div",
                      { staticClass: "flex-shrink-1" },
                      [
                        _vm.displayLabel &&
                        _vm.user.considers_himself_professional &&
                        _vm.generalLabel
                          ? _c("span", {
                              staticClass:
                                "ci-user-tile__label d-block font-weight-bold text-dark text-sm",
                              class: {
                                "ci-user-tile__advisor_label": _vm.advisorTile,
                              },
                              domProps: {
                                textContent: _vm._s(_vm.$t(_vm.generalLabel)),
                              },
                            })
                          : _vm._e(),
                        _vm.displayTileName
                          ? _c("ci-router-link", {
                              staticClass: "h6 ci-user-tile__name mb-1",
                              attrs: {
                                label: _vm.user.name,
                                disabled: _vm.linkDisabled,
                                to: _vm.linkWithTracking,
                                username: _vm.user.firstname,
                              },
                            })
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "ci-user-tile__user-position" },
                          [
                            _vm.user.position
                              ? _c("span", {
                                  staticClass: "text-dark",
                                  domProps: {
                                    textContent: _vm._s(_vm.user.position),
                                  },
                                })
                              : _vm._e(),
                            _vm.user.company_name
                              ? _c("span", {
                                  staticClass: "d-block text-dark",
                                  domProps: {
                                    textContent: _vm._s(_vm.user.company_name),
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                        _vm.location && !_vm.advisorTile
                          ? _c("span", {
                              staticClass: "d-block text-sm text-dark location",
                              domProps: { textContent: _vm._s(_vm.location) },
                            })
                          : _vm._e(),
                        _vm.withContext ? [_vm._t("default")] : _vm._e(),
                        _vm._t("custom-location"),
                        !_vm.withSendMessage && _vm.withProfileLink
                          ? _c(
                              "div",
                              {
                                staticClass: "ci-user-tile__go-to-user mt-auto",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "d-flex align-items-center font-weight-semi pt-2 cursor-pointer text-sm text-nowrap",
                                    attrs: { href: _vm.user.url },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "mdi mdi-arrow-right",
                                    }),
                                    _c("span", {
                                      staticClass: "ml-2",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "ui.components.users.tile.goto_user"
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.withSendMessage
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "ci-user-tile__send-message mt-auto",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "b-modal",
                                        rawName: "v-b-modal",
                                        value: _vm.modalId,
                                        expression: "modalId",
                                      },
                                    ],
                                    staticClass:
                                      "d-flex align-items-center font-weight-semi pt-2 cursor-pointer text-sm text-nowrap",
                                    on: {
                                      click: _vm.trackOpenMessageSendModal,
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "mdi mdi-message-text",
                                    }),
                                    _c("span", {
                                      staticClass: "ml-2",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "ui.components.users.tile.send_message"
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                                _vm.userSignedIn
                                  ? [
                                      _c("ci-direct-message-modal", {
                                        attrs: {
                                          "user-id": _vm.user.id,
                                          "modal-id": _vm.modalId,
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "flex-grow-1 d-none d-lg-flex h-100" },
                      [_vm._t("extra-content")],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "flex-grow-1 d-none d-xl-flex h-100" },
                      [_vm._t("go-to-user")],
                      2
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "d-flex d-lg-none w-100" },
        [_vm._t("extra-content")],
        2
      ),
      _c(
        "div",
        { staticClass: "d-flex d-xl-none w-100" },
        [_vm._t("go-to-user")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }